import { createAction } from 'pmt-modules/redux'

export const FrontFlowActions = {
  SET_FLOW_TYPE: 'KIOSK::SET_FLOW_TYPE',
}

export const setFlowType = flowType => createAction(FrontFlowActions.SET_FLOW_TYPE, { flowType })
